module.exports = __webpack_public_path__ + "img/Seguros-Futuro.9ec64a36.jpg";